import React from "react";
import Carousel from "react-material-ui-carousel";
import { useLocation } from "react-router-dom";
import "./adsComponent.css";

// Academic
import academic1 from "../../assests/ads/acadamic_slider_1.jpg";
import academic2 from "../../assests/ads/academic_assignments_banner.png";
// import academic3 from "../../assests/ads/acadamic_slider_1.jpg";

// Enrich
import enrich1 from "../../assests/ads/enrich_slider_1.jpg";

// Edutainment
import edu1 from "../../assests/ads/edubg.jpeg";
// import edu2 from "../../assests/ads/enrich_slider_1.jpg";

// story
import print1 from "../../assests/ads/storybg.jpeg";
// import print2 from "../../assests/ads/enrich_slider_1.jpg";

// Makers
// import maker1 from "../../assests/ads/enrich_slider_1.jpg";

// Info Hub
// import info1 from "../../assests/ads/enrich_slider_1.jpg";

export default function AdsComponent() {
  const location = useLocation();
  const bannerCategory = location.pathname.includes("/early-career") ? "Enrich"
    : location.pathname.includes("/edutainment") ? "Edutainment"
    : location.pathname.includes("/print-rich") ? "StoryHub"
    : location.pathname.includes("/info-hub") ? "My Mentor"
    : "Academic";

  let banners = [];

  if (location.pathname.includes("/academic")) {
    banners = [academic1, academic2].filter(
      (image, index, allImages) => allImages.indexOf(image) === index
    );
  } else if (location.pathname.includes("/early-career")) {
    banners = [enrich1];
  } else if (location.pathname.includes("/edutainment")) {
    banners = [edu1];
  } else if (location.pathname.includes("/print-rich")) {
    banners = [print1];
  } else if (location.pathname.includes("/maker")) {
    banners = [];
  } else if (location.pathname.includes("/info-hub")) {
    banners = [];
  } else {
    banners = [academic1];
  }

  return (
    <div
      className="adsMainContainer"
      style={{ minHeight: 'clamp(320px, 30vw, 450px)' }}
    >
    <Carousel
    autoPlay={true}
    interval={8000}
    animation="slide"
    indicators={true}
    navButtonsAlwaysVisible={false}
    navButtonsAlwaysInvisible={false}
    className="mySwiper"
    style={{ height: 'clamp(320px, 30vw, 450px)', minHeight: '320px' }}
    navButtonsProps={{
        className: "customNavButton"
    }}
>
        {banners.map((img, index) => (
          <img
            key={img}
            className="bannerSlide"
            src={img}
            alt={`${bannerCategory} banner ${index + 1}`}
          />
        ))}
      </Carousel>
    </div>
  );
}

//adding data to show caroseul sliding images 26-08-26 use this full code replace up code with this to get carosuel sliding images 
// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./adsComponent.css";

// import academic1 from "../../assests/ads/acadamic_slider_1.jpg";
// import enrich1 from "../../assests/ads/enrich_slider_1.jpg";

// export default function AdsComponent() {

//   const location = useLocation();

//   const [currentIndex, setCurrentIndex] = useState(0);

//   let banners = [];

//   if (location.pathname.includes("/academic")) {

//     banners = [
//       academic1,
//       enrich1
//     ];

//   } else if (location.pathname.includes("/early-career")) {

//     banners = [
//       enrich1,
//       academic1
//     ];

//   } else {

//     banners = [
//       academic1
//     ];

//   }


  

//   useEffect(() => {
//     setCurrentIndex(0);
//   }, [location.pathname]);


 

//   useEffect(() => {

//     if (banners.length <= 1) {
//       return;
//     }

//     const timer = setInterval(() => {

//       setCurrentIndex((previousIndex) => {

//         return (previousIndex + 1) % banners.length;

//       });

//     }, 3000);

//     return () => clearInterval(timer);

//   }, [location.pathname, banners.length]);


//   if (banners.length === 0) {
//     return null;
//   }




//   const handlePrevious = () => {

//     setCurrentIndex((previousIndex) => {

//       if (previousIndex === 0) {
//         return banners.length - 1;
//       }

//       return previousIndex - 1;

//     });

//   };



//   const handleNext = () => {

//     setCurrentIndex((previousIndex) => {

//       return (previousIndex + 1) % banners.length;

//     });

//   };


//   return (

//     <div className="adsMainContainer">

//       <div className="adsSlider">

//         {banners.map((image, index) => (

//           <div
//             key={index}
//             className={`bannerSlide ${
//               index === currentIndex ? "bannerSlideActive" : ""
//             }`}
//           >

//             <img
//               src={image}
//               alt={`Banner ${index + 1}`}
//               className="bannerImage"
//             />

//           </div>

//         ))}


//         {banners.length > 1 && (

//           <>

//             <button
//               type="button"
//               className="customNavButton customPrevButton"
//               onClick={handlePrevious}
//             >
//               ‹
//             </button>


//             <button
//               type="button"
//               className="customNavButton customNextButton"
//               onClick={handleNext}
//             >
//               ›
//             </button>

//           </>

//         )}

//       </div>

//     </div>

//   );
// }
// end
